import React from 'react'
import { Row, Col, Avatar } from 'antd'
import tankPill from '@assets/CustomIcons/tank_volume.png'
import { FormNumberInput } from '../../../../../_SiteWide/Form/FormNumberInput'

export const Volumes = ({ tank, editing }) => (
  <Row className='pr-4'>
    <Col span={8} align='left'>
      <img alt='tank pill' className='tank-volume-image' src={tankPill} />
    </Col>
    <Col span={16} className='pl-3'>
      <VolumeView
        title='Tank Size'
        value={
          <FormNumberInput
            name='tank_size'
            placeholder='Tank Size'
            width='90%'
            editable={editing}
            initialValue={tank.tank_size}
            min={0}
          />
        }
        circleClass='tank-size-circle'
        editing={editing}
      />
      <VolumeView
        title='Max Volume'
        value={
          <FormNumberInput
            name='storage_max'
            placeholder='Max Volume'
            width='90%'
            editable={editing}
            initialValue={tank.storage_max}
            min={0}
          />
        }
        circleClass='physical-max-circle'
        editing={editing}
      />
      <VolumeView
        title='Min Volume'
        value={
          <FormNumberInput
            name='fuel_bottom'
            placeholder='Min Volume'
            width='90%'
            editable={editing}
            initialValue={tank.fuel_bottom}
            min={0}
          />
        }
        circleClass='physical-min-circle'
        editing={editing}
      />
    </Col>
  </Row>
)

const VolumeView = ({ title, value, circleClass, editing }) => (
  <Row className='tank-volume-value-row'>
    <Col span={3}>
      <Avatar size={14} className={`${circleClass} avatar`} />
    </Col>
    <Col span={21}>
      <Row className='data-label'>
        <Col align='left' span={24}>
          {title}
        </Col>
      </Row>
      <Row className={`data ${!editing ? 'tank-volume-value' : ''}`}>
        <Col align='left' span={24}>
          {value}
        </Col>
      </Row>
    </Col>
  </Row>
)
